const apiReqEvnt = 'Before any API call.';
const apiResEvnt = 'After getting response from API';
const apiReqMsg = (endpoint: string) => `API called. Route: ${endpoint}`;
const apiResMsg = (endpoint: string) => `Response Received for Api: ${endpoint}`;

export { apiReqEvnt, apiResEvnt, apiReqMsg, apiResMsg };